import React from 'react';

export const OkLogo: React.FC = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 12.0039C0 5.37649 5.37258 0.00390625 12 0.00390625C18.6274 0.00390625 24 5.37649 24 12.0039C24 18.6313 18.6274 24.0039 12 24.0039C5.37258 24.0039 0 18.6313 0 12.0039Z"
      fill="#F68634"
    />
    <path
      d="M13.2979 14.7233L15.0912 16.4546C15.4586 16.8085 15.4586 17.3832 15.0912 17.7375C14.7242 18.0917 14.1294 18.0917 13.7628 17.7375L11.9996 16.0362L10.2379 17.7375C10.0542 17.9144 9.81352 18.003 9.57282 18.003C9.33251 18.003 9.0922 17.9144 8.90851 17.7375C8.54151 17.3832 8.54151 16.8088 8.90812 16.4546L10.7016 14.7233C10.0487 14.5797 9.41889 14.33 8.83883 13.9787C8.39985 13.7115 8.26799 13.1518 8.54458 12.7277C8.8204 12.303 9.40046 12.1751 9.8402 12.4423C11.1535 13.2398 12.8453 13.24 14.1593 12.4423C14.5991 12.1751 15.1789 12.303 15.4553 12.7277C15.7319 13.1514 15.5997 13.7115 15.1607 13.9787C14.5806 14.3303 13.9509 14.5797 13.2979 14.7233Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.78369 9.1007C8.78369 10.8079 10.2225 12.1966 11.9917 12.1966C13.7612 12.1966 15.1996 10.8079 15.1996 9.1007C15.1996 7.39296 13.7612 6.00391 11.9917 6.00391C10.2225 6.00391 8.78369 7.39296 8.78369 9.1007ZM13.3199 9.10059C13.3199 8.39355 12.7241 7.81862 11.9916 7.81862C11.2597 7.81862 10.6633 8.39355 10.6633 9.10059C10.6633 9.80706 11.2597 10.3824 11.9916 10.3824C12.7241 10.3824 13.3199 9.80706 13.3199 9.10059Z"
      fill="white"
    />
  </svg>
);
